/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_No_ContentInputs */

const en_course_no_content = /** @type {(inputs: Course_No_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No content available.`)
};

const ja_course_no_content = /** @type {(inputs: Course_No_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コンテンツがありません。`)
};

const fr_course_no_content = /** @type {(inputs: Course_No_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun contenu disponible.`)
};

const de_course_no_content = /** @type {(inputs: Course_No_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Inhalt verfügbar.`)
};

/**
* | output |
* | --- |
* | "No content available." |
*
* @param {Course_No_ContentInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const course_no_content = /** @type {((inputs?: Course_No_ContentInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_No_ContentInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_course_no_content(inputs)
	if (locale === "ja") return ja_course_no_content(inputs)
	if (locale === "fr") return fr_course_no_content(inputs)
	return de_course_no_content(inputs)
});